import api from "./api";


export const generateImprovedPrompt = async (data) => {
  try {
    const response = await api.post(`agent/generate-prompt`, data);
    return response.data;
  } catch (error) {
    console.error("Erro ao gerar prompt com IA:", error.response?.data || error.message);
    throw error;
  }
};

export const getAgentsByEnterprise = async (enterpriseId) => {
  try {
    const response = await api.get(`agent/house/all/${enterpriseId}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar agentes:", error.response?.data || error.message);
    return [];
  }
};

export const createAgent = async (agentData) => {
  try {
    const response = await api.post(`agent/house/${agentData.enterpriseId}`, agentData);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar agente:", error.response?.data || error.message);
    throw error;
  }
};

export const updateAgentPrompt = async (agentNumber, newPrompt) => {
  try {
    const response = await api.put(`agent/house/prompt`, { agentNumber, newPrompt });
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar prompt:", error.response?.data || error.message);
    throw error;
  }
};